import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

export const StyledText = styled(Text)`
   color: ${({ theme }) => theme.placeholder};
`;
